import api from '../../api'
import { forEach, isArray, map, set } from 'lodash'

const uploadPath = (block, target) => `admin/files/${target}/${block.id}`
const blockPath = (block, target) => `admin/${target}/${block.id}`

const uploadFile = (block, target, file) => (
  api.postFile(uploadPath(block, target), { body: file.formData })
    .then(res => res.json())
    .then(data => data.url)
)

export default function attachFiles (block, target, files) {
  const promises = []
  const content = block.block_content

  forEach(files, (value, prop) => {
    if (isArray(value)) {
      // This is a repeater prop; `value` is an array of fields,
      // each of which may contain file objects.

      forEach(value, (repeaterFiles, index) => {
        promises.push(...map(repeaterFiles, (repeaterFile, repeaterProp) => {
          return uploadFile(block, target, repeaterFile).then(url => {
            set(content, [prop, index, repeaterProp], url)
          })
        }))
      })
    } else {
      // This is a top level prop; `value` is the file object.
      promises.push(uploadFile(block, target, value).then(url => {
        set(content, prop, url)
      }))
    }
  })

  return Promise.all(promises).then(() => {
    const body = {
      block_content: content
    }

    return api.patch(blockPath(block, target), { body }).then(res => res.json())
  })
}
